<template>
  <div class="pagination-container flex justify-between items-center">
    <span class="page-info pln-color">
      Page {{ currentPage }} to {{ totalPages }} of {{ totalData }} Data
    </span>
    <div class="pagination-controls flex">
      <button @click="goToPage(1)" :disabled="currentPage === 1">
        &lt; &lt;
      </button>
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
        &lt;
      </button>
      <template v-for="pageNumber in Math.min(5, totalPages)">
        <button
          v-if="
            currentPage - 2 + pageNumber <= totalPages &&
            currentPage - 2 + pageNumber >= 1
          "
          :key="currentPage - 2 + pageNumber"
          @click="goToPage(currentPage - 2 + pageNumber)"
          :class="{ active: currentPage === currentPage - 2 + pageNumber }"
        >
          {{ currentPage - 2 + pageNumber }}
        </button>
      </template>
      <button
        @click="goToPage(currentPage + 1)"
        :disabled="currentPage === totalPages"
      >
        >
      </button>
      <button
        @click="goToPage(totalPages)"
        :disabled="currentPage === totalPages"
      >
        >>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    totalData: {
      type: Number,
      required: true,
    },
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.$emit("update:currentPage", page);
      }
    },
  },
};
</script>

<style scoped>
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-info {
  font-size: 14px;
}

.pagination-controls button {
  margin: 0 5px;
  padding: 5px 10px;
  cursor: pointer;
  border: none;
  background-color: white;
}

.pagination-controls button.active {
  background-color: #00A2B9;
  color: white;
  border-radius: 50px;
}

.pagination-controls button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
